import * as Action from './ActionTypes';

export const initialState = {
  showLockedDeviceModal: false,
};

function showDeviceLockedModalReducer(state = initialState, actions) {
  switch (actions.type) {
    case Action.SHOW_DEVICELOCK_MODAL:
      return { ...state, showLockedDeviceModal: true };
    case Action.HIDE_DEVICELOCK_MODAL:
      return { ...state, showLockedDeviceModal: false };
    default:
      return state;
  }
}
export default showDeviceLockedModalReducer;
